export default __webpack_public_path__ + "static/media/manage-allocation.15df8d3c.svg";